import { useState } from "react";
import { Plus } from "lucide-react";
import { SendPrescriptionForm } from "pages/patient/PatientMedicationPage/components/Prescriptions/Table/SendPrescriptionForm";

import { AddPrescriptionForm } from "components/AddPrescriptionForm/AddPrescriptionForm";
import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

export const AddPrescriptionModal = ({
  isDisabled,
  buttonClassName,
  icon = Plus,
  consultationId,
  initialData,
  initialMedications,
  isRenewal = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [step, setStep] = useState("form");
  const [savedPrescriptionId, setSavedPrescriptionId] = useState(null);

  const patientId = useCurrentPatientId();

  const handleClose = () => {
    setIsModalOpen(false);
    setStep("form");
    setSavedPrescriptionId(null);
  };

  const handleFormSuccess = (res) => {
    if (!initialData && res?.id) {
      setSavedPrescriptionId(res.id);
      setStep("send");
    } else {
      handleClose();
    }
  };

  const isSendStep = step === "send";

  return (
    <>
      <Button
        variant="text"
        className={buttonClassName}
        type="button"
        disabled={isDisabled}
        onClick={() => setIsModalOpen(true)}
        endIcon={icon}
      >
        {initialData
          ? "Edit prescription"
          : isRenewal
          ? "Renew prescription"
          : "Add new prescription"}
      </Button>
      <Dialog
        open={isModalOpen}
        title={
          isSendStep
            ? "Send to pharmacy"
            : initialData
            ? "Edit prescription"
            : isRenewal
            ? "Renew prescription"
            : "Add prescription"
        }
        onClose={handleClose}
        width={isSendStep ? 560 : 1100}
      >
        {isSendStep ? (
          <SendPrescriptionForm
            prescriptionId={savedPrescriptionId}
            patientId={patientId}
            onSuccess={handleClose}
            onSkip={handleClose}
          />
        ) : (
          <AddPrescriptionForm
            consultationId={consultationId}
            onSuccess={handleFormSuccess}
            onCancel={handleClose}
            initialData={initialData}
            initialMedications={initialMedications}
            isRenewal={isRenewal}
          />
        )}
      </Dialog>
    </>
  );
};
